module.exports = __webpack_public_path__ + "./docs/img/big-icon-prop.c9cf5c8c482f8eaf4edc917248e0316f.svg";